import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';

export default class ButtonLink extends Component {
  constructor(props) {
    super(props);

    this.handleClick = this.handleClick.bind(this);
  }

  handleClick(e) {
    if (this.props.disabled) {
      e.preventDefault();
    } else if (this.props.onClick) {
      this.props.onClick();
    }
  }

  render() {
    const { children, icon, to, disabled, alt, className } = this.props;
    return (
      <Link
        onClick={this.handleClick}
        to={to}
        className={`fe-u-btnlink ${disabled ? 'disabled' : ''} ${
          alt ? 'alt' : ''
        } ${className ? className : ''}`}
      >
        <span>{children}</span>
        {icon && <img src={icon} alt='' />}
      </Link>
    );
  }
}

ButtonLink.propTypes = {
  children: PropTypes.string.isRequired,
  to: PropTypes.string.isRequired,
  icon: PropTypes.string,
  disabled: PropTypes.bool.isRequired,
  alt: PropTypes.bool.isRequired,
  onClick: PropTypes.func,
  className: PropTypes.string
};

ButtonLink.defaultProps = {
  disabled: false,
  alt: false
};
